<div class="bb-stack">
  <div class="d-none d-md-block bb-stack__item">
    <span class="sr-only" i18n="@@beneficiary.selector.ui.group.account.own.account">Own Account</span>
    <bb-icon-ui size="xl" color="primary" class="bb-stack" name="current-accounts"> </bb-icon-ui>
  </div>

  <div class="bb-stack__item">
    <span class="sr-only" i18n="@@beneficiary.selector.ui.account.name.label" id="account_accountNameLabel">
      Account name:
    </span>
    <div class="bb-text-bold" data-role="beneficiary-account-name-list-item">
      {{ account?.name }}
    </div>

    <span class="sr-only" i18n="@@beneficiary.selector.ui.account.number.label" id="account_accountNumberLabel">
      Account number:
    </span>
    <div class="text-dark" data-role="beneficiary-account-number-list-item">
      {{ accountNumber }}
    </div>
  </div>

  <ng-container>
    <div class="d-flex flex-column bb-stack__item bb-stack__item--push-right bb-stack__break--sm-down">
      <ng-container *ngFor="let balance of balances">
        <span class="sr-only" i18n="@@beneficiary.selector.ui.balance.label" id="account_accountBalanceLabel">
        Account balance:
      </span>

        <bb-amount-ui
          class="bb-text-bold"
          [amount]="balance.amount"
          [mapCurrency]="false"
          [currency]="balance.currency + ' '"
          [bbHighlight]="false"
          [attr.data-role]="'beneficiary-account-amount-list-item'"
        ></bb-amount-ui>
      </ng-container>
    </div>
  </ng-container>
</div>
